import getLinkHref from '@/modules/utils/api/getLinkHref'
import clientHTTP from '@/modules/clientHTTP'

const getMulticastGroups = (application, params = {}) => {
  return clientHTTP.get(getLinkHref(application, 'multicastGroups'), params)
}

const createMulticastGroup = (application, params = {}) => {
  return clientHTTP.post(getLinkHref(application, 'multicastGroups'), params)
}

const getMulticastGroup = (application, id) => {
  return clientHTTP.get(getLinkHref(application, 'multicastGroups') + `/${id}`)
}

const updateMulticastGroup = (multicastGroup, params = {}) => {
  return clientHTTP.patch(getLinkHref(multicastGroup, 'self'), params)
}

const deleteMulticastGroup = (multicastGroup) => {
  return clientHTTP.delete(getLinkHref(multicastGroup, 'self'))
}

const getMulticastDataDown = (application, params = {}) => {
  return clientHTTP.get(getLinkHref(application, 'multicastDataDown'), params)
}

const createMulticastDataDown = (application, params = {}) => {
  return clientHTTP.post(getLinkHref(application, 'multicastDataDown'), params)
}

const cancelOneMulticastDataDown = (dataDown) => {
  return clientHTTP.delete(getLinkHref(dataDown, 'self') + '?cancel=true')
}

export default {
  getMulticastGroups,
  createMulticastGroup,
  getMulticastGroup,
  updateMulticastGroup,
  deleteMulticastGroup,
  getMulticastDataDown,
  createMulticastDataDown,
  cancelOneMulticastDataDown
}
